import { useContext } from "react";
import { Outlet } from "react-router-dom";
import PageTabs from "@/components/PageTabs";
import PageTitle from "@/components/PageTitle";
import RequestCampaignButton from "@/components/RequestTemplateButton";
import { ProviderConfigContext } from "@/providers/ProviderConfigContext";
import { isAllowed } from "@/providers/utils";
import { accountTabs } from "./helpers";

function AccountSettings() {
  const { allowedRoutes } = useContext(ProviderConfigContext);
  const visibleTabs = accountTabs.filter((tab) =>
    isAllowed(tab.routeKey, allowedRoutes)
  );

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <PageTitle title="My account" />
        <RequestCampaignButton />
      </div>
      <PageTabs tabs={visibleTabs} />
      <Outlet />
    </>
  );
}

export { AccountSettings };
export * from "./Profile";
export * from "./AiTuning";
export * from "./Plans";
export * from "./SenderDetails";
export * from "./DNSAuthentication/DNSAuthentication";
